import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function setMultiSelectModeReducer(state = initialState.isMultiSelectMode, action) {
	switch (action.type) {
		case types.SET_MULTI_SELECT: {
			return action.value;
		}
		default:
			return state;
	}
}
